import { UndoManager } from 'yjs';
import { yRoot, yCustomNodeDatas } from '@/shared/config/yjs-config';

let undoManager: UndoManager | null = null;

/**
 * 创建 UndoManager 单例
 * 监听 root Map 和自定义节点数据，自动记录历史
 *
 * 使用单一 UndoManager 监听多个 scope，解决时间顺序问题：
 * - 单一 UndoManager 监听所有操作
 * - 撤销/重做按正确的时间顺序执行
 * - 避免节点、边、自定义节点数据分别维护历史带来的顺序冲突
 */
export function createUndoManager(): UndoManager {
  if (undoManager) {
    return undoManager;
  }

  // 同时监听 root Map（节点/边）和自定义节点数据
  undoManager = new UndoManager([yRoot, yCustomNodeDatas]);

  console.log('[UndoManager] Created for root Map + customNodeDatas');

  return undoManager;
}

/**
 * 获取 UndoManager 实例
 */
export function getUndoManager(): UndoManager | null {
  return undoManager;
}

/**
 * 销毁 UndoManager
 */
export function destroyUndoManager(): void {
  if (undoManager) {
    undoManager.clear();
    undoManager = null;
    console.log('[UndoManager] Destroyed');
  }
}
